<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
            <div class="card-header-actions">
              <CButton  class="ml-2 " size="sm" color="light" shape="pill" variant="outline" @click="onReload">
                <span class="font-weight-bold " v-c-tooltip.hover.click="'Reload'"><CIcon name="cil-reload" /></span>
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <CTabs add-tab-classes="mt-1">
              <CTab v-for="(objs,index) in item" :key="objs.id || index">
                <template slot="title">
                  <CIcon name="cil-calculator"/> {{objs.title}}
                </template>
                <CCardBody>
                  <Timeline v-if="objs.historys.length > 0 && index === 0" :objs="objs"/>
                  <History :item="objs.historys" :fields="objs.fields" @info="yourself" />
                </CCardBody>
              </CTab>

            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import History from "@/projects/views/E-Performances/Estimate/components/Historys";
import Timeline from "@/projects/views/E-Performances/Estimate/component/Timeline.vue";

export default {
  name: 'Activitys',
  components: {Timeline, History, Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    item:{
      type: Array,
      default() {
        return []
      }
    }
  },
  data: function () {
    return {

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.$store.dispatch("affiliation/config",{})

    },

    yourself(item){
      // item.type = this.item.type
      this.$emit('info',item)
    },

    onReload(){
      this.$emit("reload",{})
    }

  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
    }),
  },

  watch: {

  }

}
</script>
<style>


</style>
